import { Platform } from 'react-native';

const FALLBACK_PRICES = {
  standard_monthly: { price: '4.99', currency: 'USD', localizedPrice: '$4.99' },
  standard_yearly: { price: '49.99', currency: 'USD', localizedPrice: '$49.99' },
  premium_monthly: { price: '9.99', currency: 'USD', localizedPrice: '$9.99' },
  premium_yearly: { price: '99.99', currency: 'USD', localizedPrice: '$99.99' },
};

export type SubscriptionPrices = typeof FALLBACK_PRICES;

export function getDefaultSubscriptionPrices(): SubscriptionPrices {
  return FALLBACK_PRICES;
}

export async function fetchSubscriptionPrices(): Promise<SubscriptionPrices> {
  // Cloud Function has no CORS headers; web + SW would block cross-origin fetch.
  if (Platform.OS === 'web') {
    return FALLBACK_PRICES;
  }

  try {
    const response = await fetch(
      'https://us-central1-goalmint-d68e6.cloudfunctions.net/getSubscriptionPrices'
    );
    if (!response.ok) throw new Error('Failed to fetch prices');
    return await response.json();
  } catch {
    return FALLBACK_PRICES;
  }
} 